module.exports = __webpack_public_path__ + "static/img/shfjgszzzyhzs_1.70364de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shfjgszzzyhzs_1.jpg
// module id = 8SLu
// module chunks = 15